import { render, staticRenderFns } from "./UserItemNew.vue?vue&type=template&id=2d72c88f&scoped=true&"
import script from "./UserItemNew.vue?vue&type=script&lang=js&"
export * from "./UserItemNew.vue?vue&type=script&lang=js&"
import style0 from "./UserItemNew.vue?vue&type=style&index=0&id=2d72c88f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d72c88f",
  null
  
)

export default component.exports